// extracted by mini-css-extract-plugin
export default {"footerText":"styles_footerText__oQXrQ"};